import { render, staticRenderFns } from "./CalendarsCrud.vue?vue&type=template&id=7fd8b2bf"
import script from "./CalendarsCrud.vue?vue&type=script&lang=js"
export * from "./CalendarsCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports